<div class="quote" [innerHtml]="htmlText"></div>
